import { Component, ElementRef, EventEmitter, Input, OnInit, Optional, Output, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { TagCategory, UserTagsService } from '../../../../services/user/userTags.service';
import { ShutterService } from '../../../../features/filter/shutter/services/shutter.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertService } from '../../../../services/alert/alert.service';
import { WaitingService } from '../../../../features/layout/waiting/waiting.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRippleModule } from '@angular/material/core';
import { CommonModule } from '@angular/common';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
    selector: 'app-filter-category-dialog',
    standalone: true,
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        MatSelectModule,
        MatIconModule,
        MatProgressSpinnerModule,
        MatRippleModule
    ],
    templateUrl: './filter-category-dialog.component.html',
    styleUrl: './filter-category-dialog.component.scss',
    animations: [
        trigger('openClose', [
            state('open', style({
                left: '0px',
            })),
            state('close', style({
                left: '-100%',
            })),
            transition('open <=> close', animate('0.3s ease-in-out'))
        ])
    ]
})
export class FilterCategoryDialogComponent implements OnInit {
    @Input() isMobile?: boolean = false;
    @Input() public shutterName = 'Filtrer vos écrans';
    @Input() public groupedBy?: any = null;
    @Input() public displayMobileFilterPanel?: boolean = false;

    /**
     * Event triggered quand le fioltre est changé et validé en vue mobile 
     */
    @Output() public filterChanged = new EventEmitter<boolean>;
    @Output() public groupByChanged = new EventEmitter<number>;

    public categoriesAndTag: TagCategory[];
    public isTagsLoaded: boolean = false;
    selection: any;
    menuChanged: boolean = false;
    allModels: any[] = [];
    mobileSelectedCat: any;
    groupByName: string = null;
    @ViewChild('focusDiv') focusDivRef!: ElementRef;
    //#region Variables

    //#endregion Variables

    // MARK: CONSTRUCTOR
    constructor(
        private readonly waiting$: WaitingService,
        private readonly shutter$: ShutterService,
        private readonly alert$: AlertService,
        @Optional() public dialogRef: MatDialogRef<FilterCategoryDialogComponent>
    ) { }

    ngOnInit(): void {
        this.loadAllTags();
        this.selection = UserTagsService.getTagsSelection(this.shutterName);


        this.categoriesAndTag?.forEach(cat => {
            if (this.selection.has(cat.n)) {
                this.allModels.push((this.selection.get(cat.n)).t.map(t => t.n));
            } else {
                this.allModels.push([]);
            }
        });

        if (this.groupedBy != null) {
            this.groupByName = this.categoriesAndTag.find(c => c.i === this.groupedBy).n;
        }

    }

    ngOnChanges(change) {
        if (change?.displayMobileFilterPanel?.currentValue) {
            
            this.ngOnInit();

            if(change?.displayMobileFilterPanel?.currentValu == true){
                document.body.classList.add('modal-open'); // À la fermeture
                setTimeout(() => {
                    this.focusDivRef.nativeElement.focus();
                }, 100);
            }
            else{
                document.body.classList.remove('modal-open'); // À la fermeture
            }

        }
    }

    private loadAllTags() {
        const waitingId: string = this.waiting$.start();
        this.shutter$.getAllTags().subscribe({
            next: (val) => {
                this.waiting$.end(waitingId);
                this.categoriesAndTag = val;


                this.isTagsLoaded = true;
            },
            error: (err: HttpErrorResponse) => {
                this.waiting$.end(waitingId);
                console.error("WncmScreenFilterComponent - loadShutterTags() : ", err);

                if (err.status != 401) {
                    this.alert$.show({
                        message: "Erreur lors du chargement des tags",
                        duration: 1700
                    }, 0);
                }

                this.isTagsLoaded = true;

            }
        });
    }

    getModel(cat) {
        const listTag = this.selection.get(cat.n);

        return listTag ?? [];

    }

    selectSubMenu(tag, cat) {
        if (this.selection.has(cat.n)) {
            const listTag = this.selection.get(cat.n);
            const index = listTag.t.findIndex(t => t.n === tag.n);
            if (index === -1) {
                listTag.t.push(tag)
            }
            else {
                listTag.t.splice(index, 1);
                if (listTag.t.length === 0)
                    this.selection.delete(cat.n);
            }
        }
        else {
            this.selection.set(cat.n, { i: tag.i, c: null, n: tag.n, t: [tag] });
        }
        // UserTagsService.setTagsSelection(this.shutterName, this.selection);
        // this.initFilterParams();
    }

    validFilter() {
        this.menuChanged = true;
        UserTagsService.setTagsSelection(this.shutterName, this.selection);

        if (!this.isMobile) {
            this.dialogRef.close(true);
        } else {
            this.mobileSelectedCat = null;

            //Emit event close
            this.filterChanged.emit(true);
            this.ngOnInit();
        }
    }

    selectCategoryMobile(cat) {
        this.mobileSelectedCat = cat;

    }

    isTagSelected(tag, cat): boolean {
        if (this.selection.has(cat.n)) {
            const listTag = this.selection.get(cat.n);
            const index = listTag.t.findIndex(t => t.n === tag.n);
            return index !== -1
        } else {
            return false;
        }
    }

    goBack() {
        if (this.mobileSelectedCat != null) {
            this.mobileSelectedCat = null;
        } else {
            this.validFilter();
        }
    }

    groupBy(groupById: number) {
        this.groupByChanged.emit(groupById);
        this.validFilter();
    }

    /**
     * hasGroupByOptions
     */
    public hasGroupByOptions(): boolean {
        return this.categoriesAndTag?.findIndex(c => c.i != null) !== -1;
    }



}
